/* eslint-disable no-prototype-builtins */
import Long from 'long'
import _ from 'lodash'
import { AppConfig } from '@/appConfig' // note this is specific to each app!

const morphologyFeaturesPlus = require('shared/js/morphology_features_plus')
var morphologyIdDict = {}
morphologyFeaturesPlus.all_list_names.forEach(listName => {
  morphologyFeaturesPlus[listName].forEach(feature => {
    morphologyIdDict[feature.code] = feature[AppConfig.MORPHOLOGY_LANGUAGE]
  })
})
// these three also used below [near the end of in prettyPrintedMorphArray()]
morphologyIdDict['PREFIX'] = 'תחילית:' // 'prefix:'
morphologyIdDict['BASEFORM'] = 'בסיס:' // 'baseform:'
morphologyIdDict['SUFFIX'] = 'סיומת:' // 'suffix:'

// Prefix
// Function
// bits 2-3, 5,7, 9-11
const PREFIX_FUNCTION_CONJUNCTION = 0x2
const PREFIX_FUNCTION_DEFINITEARTICLE = 0x4
const PREFIX_FUNCTION_INTERROGATIVE = 0x10
const PREFIX_FUNCTION_PREPOSITION = 0x40
const PREFIX_FUNCTION_RELATIVIZER_SUBORDINATINGCONJUNCTION = 0x100
const PREFIX_FUNCTION_TEMPORALSUBCONJ = 0x200
const PREFIX_FUNCTION_ADVERB = 0x400
// const PREFIX_MASK = 0x756
// POS
// bits 17-21
const BASEFORM_POS = 0x1f0000
const BASEFORM_POS_CONTINUE = 0x0
const BASEFORM_POS_ADJECTIVE = 0x10000
const BASEFORM_POS_ADVERB = 0x20000
const BASEFORM_POS_CONJUNCTION = 0x30000
const BASEFORM_POS_AT_PREP = 0x40000
const BASEFORM_POS_NEGATION = 0x50000
const BASEFORM_POS_NOUN = 0x60000
const BASEFORM_POS_NUMERAL = 0x70000
const BASEFORM_POS_PREPOSITION = 0x80000
const BASEFORM_POS_PRONOUN = 0x90000
const BASEFORM_POS_PROPERNAME = 0xa0000
const BASEFORM_POS_CITATION = 0xb0000
const BASEFORM_POS_INITIALISM = 0xc0000
const BASEFORM_POS_VERB = 0xd0000
const BASEFORM_POS_PUNCTUATION = 0xe0000
const BASEFORM_POS_INTERROGATIVE = 0xf0000
const BASEFORM_POS_INTERJECTION = 0x100000
const BASEFORM_POS_UNKNOWN = 0x110000
const BASEFORM_POS_QUANTIFIER = 0x120000
const BASEFORM_POS_EXISTENTIAL = 0x130000
const BASEFORM_POS_MODAL = 0x140000
const BASEFORM_POS_PREFIX = 0x150000
const BASEFORM_POS_URL = 0x160000
const BASEFORM_POS_FOREIGN = 0x170000
const BASEFORM_POS_JUNK = 0x180000
const BASEFORM_POS_UNCLEAR = 0x190000
const BASEFORM_POS_PARTICIPLE = 0x1a0000
const BASEFORM_POS_COPULA = 0x1b0000
const BASEFORM_POS_REF = 0x1c0000
const BASEFORM_POS_TITULAR = 0x1d0000
const BASEFORM_POS_SHEL_PREP = 0x1e0000
const BASEFORM_POS_NONSTANDARD = 0x1f0000
// Gender
//bits 22-23
const BASEFORM_GENDER = 0x600000
const BASEFORM_GENDER_MASCULINE = 0x200000
const BASEFORM_GENDER_FEMININE = 0x400000
const BASEFORM_GENDER_MASCULINEFEMININE = 0x600000
// Number
// bits 25-27
const BASEFORM_NUMBER = 0x7000000
const BASEFORM_NUMBER_SINGULAR = 0x1000000
const BASEFORM_NUMBER_PLURAL = 0x2000000
const BASEFORM_NUMBER_DUAL = 0x3000000
const BASEFORM_NUMBER_DUALPLURAL = 0x4000000
const BASEFORM_NUMBER_SINGULARPLURAL = 0x5000000
// Person
// bits 28-30
const BASEFORM_PERSON = 0x38000000
const BASEFORM_PERSON_1 = 0x8000000
const BASEFORM_PERSON_2 = 0x10000000
const BASEFORM_PERSON_3 = 0x18000000
const BASEFORM_PERSON_ANY = 0x20000000
// Status
// bits 31-32
const BASEFORM_STATUS = Long.fromString('c0000000', false, 16)
const BASEFORM_STATUS_ABSOLUTE = Long.fromString('40000000', false, 16)
const BASEFORM_STATUS_CONSTRUCT = Long.fromString('80000000', false, 16)
const BASEFORM_STATUS_ABSOLUTECONSTRUCT = Long.fromString('c0000000', false, 16)
// Tense
// bits 34-36
const BASEFORM_TENSE = Long.fromString('e00000000', false, 16)
const BASEFORM_TENSE_PAST = Long.fromString('200000000', false, 16)
const BASEFORM_TENSE_ALLTIME = Long.fromString('400000000', false, 16)
const BASEFORM_TENSE_PRESENT = Long.fromString('600000000', false, 16)
const BASEFORM_TENSE_FUTURE = Long.fromString('800000000', false, 16)
const BASEFORM_TENSE_IMPERATIVE = Long.fromString('a00000000', false, 16)
const BASEFORM_TENSE_TOINFINITIVE = Long.fromString('c00000000', false, 16)
const BASEFORM_TENSE_BAREINFINITIVE = Long.fromString('e00000000', false, 16)
// Function
// bits 37-38
const SUFFIX_FUNCTION = Long.fromString('3000000000', false, 16)
const SUFFIX_FUNCTION_POSSESIVEPRONOUN = Long.fromString('1000000000', false, 16)
const SUFFIX_FUNCTION_ACCUSATIVENOMINATIVE = Long.fromString('2000000000', false, 16)
const SUFFIX_FUNCTION_PRONOMIAL = Long.fromString('3000000000', false, 16)
// const SUFFIX_MASK = SUFFIX_FUNCTION
//////////////////////
// BIT 42 IS fARAMAIC! 
const FULLFORM_ARAMAIC = 0x20000000000
//////////////////////
const SUFFIX_GENDER = 0x18000000000
const SUFFIX_GENDER_MASCULINE = 0x8000000000
const SUFFIX_GENDER_FEMININE = 0x10000000000
const SUFFIX_GENDER_MASCULINEFEMININE = 0x18000000000
const SUFFIX_NUMBER = 0x1c0000000000
const SUFFIX_NUMBER_SINGULAR = 0x40000000000
const SUFFIX_NUMBER_PLURAL = 0x80000000000
const SUFFIX_PERSON = 0xe00000000000
const SUFFIX_PERSON_1 = 0x200000000000
const SUFFIX_PERSON_2 = 0x400000000000
const SUFFIX_PERSON_3 = 0x600000000000
const SUFFIX_PERSON_ANY = 0x800000000000

// Binyan
// bits ?? (supplied later)
const BASEFORM_BINYAN = 0x38000000000000
const BASEFORM_BINYAN_PAAL = 0x8000000000000
const BASEFORM_BINYAN_NIFAL = 0x10000000000000
const BASEFORM_BINYAN_HIFIL = 0x18000000000000
const BASEFORM_BINYAN_HUFAL = 0x20000000000000
const BASEFORM_BINYAN_PIEL = 0x28000000000000
const BASEFORM_BINYAN_PUAL = 0x30000000000000
const BASEFORM_BINYAN_HITPAEL = 0x38000000000000

// Lists of the bitmasks
const SUFFIX_FUNCTION_LIST = [0, SUFFIX_FUNCTION_POSSESIVEPRONOUN, SUFFIX_FUNCTION_ACCUSATIVENOMINATIVE, SUFFIX_FUNCTION_PRONOMIAL]
const BASEFORM_POS_LIST = [BASEFORM_POS_CONTINUE, BASEFORM_POS_ADJECTIVE, BASEFORM_POS_ADVERB, BASEFORM_POS_CONJUNCTION, BASEFORM_POS_AT_PREP, BASEFORM_POS_NEGATION, BASEFORM_POS_NOUN, BASEFORM_POS_NUMERAL, BASEFORM_POS_PREPOSITION, BASEFORM_POS_PRONOUN, BASEFORM_POS_PROPERNAME, BASEFORM_POS_CITATION, BASEFORM_POS_INITIALISM, BASEFORM_POS_VERB, BASEFORM_POS_PUNCTUATION, BASEFORM_POS_INTERROGATIVE, BASEFORM_POS_INTERJECTION, BASEFORM_POS_UNKNOWN, BASEFORM_POS_QUANTIFIER, BASEFORM_POS_EXISTENTIAL, BASEFORM_POS_MODAL, BASEFORM_POS_PREFIX, BASEFORM_POS_URL, BASEFORM_POS_FOREIGN, BASEFORM_POS_JUNK, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_COPULA, BASEFORM_POS_REF, BASEFORM_POS_TITULAR, BASEFORM_POS_SHEL_PREP, BASEFORM_POS_UNCLEAR, BASEFORM_POS_NONSTANDARD]
const BASEFORM_GENDER_LIST = [0, BASEFORM_GENDER_MASCULINE, BASEFORM_GENDER_FEMININE, BASEFORM_GENDER_MASCULINEFEMININE]
const BASEFORM_NUMBER_LIST = [0, BASEFORM_NUMBER_SINGULAR, BASEFORM_NUMBER_PLURAL, BASEFORM_NUMBER_DUAL, BASEFORM_NUMBER_DUALPLURAL, BASEFORM_NUMBER_SINGULARPLURAL]
const BASEFORM_PERSON_LIST = [0, BASEFORM_PERSON_1, BASEFORM_PERSON_2, BASEFORM_PERSON_3, BASEFORM_PERSON_ANY]
const BASEFORM_STATUS_LIST = [0, BASEFORM_STATUS_ABSOLUTE, BASEFORM_STATUS_CONSTRUCT, BASEFORM_STATUS_ABSOLUTECONSTRUCT]
const BASEFORM_TENSE_LIST = [0, BASEFORM_TENSE_PAST, BASEFORM_TENSE_ALLTIME, BASEFORM_TENSE_PRESENT, BASEFORM_TENSE_FUTURE, BASEFORM_TENSE_IMPERATIVE, BASEFORM_TENSE_TOINFINITIVE, BASEFORM_TENSE_BAREINFINITIVE]
const BASEFORM_BINYAN_LIST = [0, BASEFORM_BINYAN_PAAL, BASEFORM_BINYAN_NIFAL, BASEFORM_BINYAN_HIFIL, BASEFORM_BINYAN_HUFAL, BASEFORM_BINYAN_PIEL, BASEFORM_BINYAN_PUAL, BASEFORM_BINYAN_HITPAEL]

// Convert them to string
const BASEFORM_POS_NUM_TO_STR = ["BASEFORM_POS_CONTINUE", "BASEFORM_POS_ADJECTIVE", "BASEFORM_POS_ADVERB", "BASEFORM_POS_CONJUNCTION", "BASEFORM_POS_AT_PREP", "BASEFORM_POS_NEGATION", "BASEFORM_POS_NOUN", "BASEFORM_POS_NUMERAL", "BASEFORM_POS_PREPOSITION", "BASEFORM_POS_PRONOUN", "BASEFORM_POS_PROPERNAME", "BASEFORM_POS_CITATION", "BASEFORM_POS_INITIALISM", "BASEFORM_POS_VERB", "BASEFORM_POS_PUNCTUATION", "BASEFORM_POS_INTERROGATIVE", "BASEFORM_POS_INTERJECTION", "BASEFORM_POS_UNKNOWN", "BASEFORM_POS_QUANTIFIER", "BASEFORM_POS_EXISTENTIAL", "BASEFORM_POS_MODAL", "BASEFORM_POS_PREFIX", "BASEFORM_POS_URL", "BASEFORM_POS_FOREIGN", "BASEFORM_POS_JUNK", "BASEFORM_POS_PARTICIPLE", "BASEFORM_POS_COPULA", "BASEFORM_POS_REF", "BASEFORM_POS_TITULAR", "BASEFORM_POS_SHEL_PREP", "BASEFORM_POS_UNCLEAR", "BASEFORM_POS_NONSTANDARD"]
const SUFFIX_FUNCTION_NUM_TO_STR = ["_UNK_", "SUFFIX_FUNCTION_POSSESIVEPRONOUN", "SUFFIX_FUNCTION_ACCUSATIVENOMINATIVE", "SUFFIX_FUNCTION_PRONOMIAL"]
const BASEFORM_GENDER_NUM_TO_STR = ["_UNK_", "BASEFORM_GENDER_MASCULINE", "BASEFORM_GENDER_FEMININE", "BASEFORM_GENDER_MASCULINEFEMININE"]
const BASEFORM_NUMBER_NUM_TO_STR = ["_UNK_", "BASEFORM_NUMBER_SINGULAR", "BASEFORM_NUMBER_PLURAL", "BASEFORM_NUMBER_DUAL", "BASEFORM_NUMBER_DUALPLURAL", "BASEFORM_NUMBER_SINGULARPLURAL"]
const BASEFORM_PERSON_NUM_TO_STR = ["_UNK_", "BASEFORM_PERSON_1", "BASEFORM_PERSON_2", "BASEFORM_PERSON_3", "BASEFORM_PERSON_ANY"]
const BASEFORM_STATUS_NUM_TO_STR = ["_UNK_", "BASEFORM_STATUS_ABSOLUTE", "BASEFORM_STATUS_CONSTRUCT", "BASEFORM_STATUS_ABSOLUTECONSTRUCT"]
const BASEFORM_TENSE_NUM_TO_STR = ["_UNK_", "BASEFORM_TENSE_PAST", "BASEFORM_TENSE_ALLTIME", "BASEFORM_TENSE_PRESENT", "BASEFORM_TENSE_FUTURE", "BASEFORM_TENSE_IMPERATIVE", "BASEFORM_TENSE_TOINFINITIVE", "BASEFORM_TENSE_BAREINFINITIVE"]
const BASEFORM_BINYAN_NUM_TO_STR = ["_UNK_", "BASEFORM_BINYAN_PAAL", "BASEFORM_BINYAN_NIFAL", "BASEFORM_BINYAN_HIFIL", "BASEFORM_BINYAN_HUFAL", "BASEFORM_BINYAN_PIEL", "BASEFORM_BINYAN_PUAL", "BASEFORM_BINYAN_HITPAEL"]

// My own additions
const PREFIX_FUNCTION_LIST = [PREFIX_FUNCTION_CONJUNCTION, PREFIX_FUNCTION_DEFINITEARTICLE, PREFIX_FUNCTION_INTERROGATIVE, PREFIX_FUNCTION_PREPOSITION, PREFIX_FUNCTION_RELATIVIZER_SUBORDINATINGCONJUNCTION, PREFIX_FUNCTION_TEMPORALSUBCONJ, PREFIX_FUNCTION_ADVERB]
const PREFIX_FUNCTION_NUM_TO_STR = ['PREFIX_FUNCTION_CONJUNCTION', 'PREFIX_FUNCTION_DEFINITEARTICLE', 'PREFIX_FUNCTION_INTERROGATIVE', 'PREFIX_FUNCTION_PREPOSITION', 'PREFIX_FUNCTION_RELATIVIZER_SUBORDINATINGCONJUNCTION', 'PREFIX_FUNCTION_TEMPORALSUBCONJ', 'PREFIX_FUNCTION_ADVERB']
const SUFFIX_GENDER_LIST = [SUFFIX_GENDER_MASCULINE, SUFFIX_GENDER_FEMININE, SUFFIX_GENDER_MASCULINEFEMININE]
const SUFFIX_GENDER_NUM_TO_STR = ['SUFFIX_GENDER_MASCULINE', 'SUFFIX_GENDER_FEMININE', 'SUFFIX_GENDER_MASCULINEFEMININE']
const SUFFIX_NUMBER_LIST = [SUFFIX_NUMBER_SINGULAR, SUFFIX_NUMBER_PLURAL]
const SUFFIX_NUMBER_NUM_TO_STR = ['SUFFIX_NUMBER_SINGULAR', 'SUFFIX_NUMBER_PLURAL']
const SUFFIX_PERSON_LIST = [SUFFIX_PERSON_1, SUFFIX_PERSON_2, SUFFIX_PERSON_3, SUFFIX_PERSON_ANY]
const SUFFIX_PERSON_NUM_TO_STR = ['SUFFIX_PERSON_1', 'SUFFIX_PERSON_2', 'SUFFIX_PERSON_3', 'SUFFIX_PERSON_ANY']

/* NOT USED, AS OF NOW:
// a mask with everything we care about
const MANUAL_TAGGING_MASK = PREFIX_MASK | BASEFORM_POS | SUFFIX_FUNCTION | BASEFORM_TENSE | BASEFORM_STATUS | BASEFORM_NUMBER | BASEFORM_PERSON | BASEFORM_GENDER
// the list of hierarchy for pos..
const POS_WITH_GENDER_AND_NUMBER = [BASEFORM_POS_NOUN, BASEFORM_POS_ADJECTIVE, BASEFORM_POS_NUMERAL, BASEFORM_POS_PROPERNAME, BASEFORM_POS_PRONOUN, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_VERB, BASEFORM_POS_QUANTIFIER, BASEFORM_POS_EXISTENTIAL, BASEFORM_POS_COPULA, BASEFORM_POS_MODAL, BASEFORM_POS_TITULAR]
const POS_WITH_PERSON = [BASEFORM_POS_PRONOUN, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_VERB, BASEFORM_POS_EXISTENTIAL, BASEFORM_POS_MODAL, BASEFORM_POS_COPULA]
const POS_WITH_STATUS = [BASEFORM_POS_NOUN, BASEFORM_POS_ADJECTIVE, BASEFORM_POS_NUMERAL, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_QUANTIFIER]
const POS_WITH_TENSE = [BASEFORM_POS_VERB, BASEFORM_POS_EXISTENTIAL, BASEFORM_POS_MODAL, BASEFORM_POS_COPULA]
const POS_WITH_PREFIX = [BASEFORM_POS_PREFIX, BASEFORM_POS_INTERJECTION, BASEFORM_POS_TITULAR, BASEFORM_POS_COPULA, BASEFORM_POS_AT_PREP, BASEFORM_POS_SHEL_PREP, BASEFORM_POS_MODAL, BASEFORM_POS_NEGATION, BASEFORM_POS_EXISTENTIAL, BASEFORM_POS_QUANTIFIER, BASEFORM_POS_INTERROGATIVE, BASEFORM_POS_CONJUNCTION, BASEFORM_POS_ADVERB, BASEFORM_POS_PREPOSITION, BASEFORM_POS_VERB, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_PRONOUN, BASEFORM_POS_PROPERNAME, BASEFORM_POS_NUMERAL, BASEFORM_POS_ADJECTIVE, BASEFORM_POS_NOUN]
const POS_WITH_SUFFIX = [BASEFORM_POS_NOUN, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_QUANTIFIER, BASEFORM_POS_COPULA, BASEFORM_POS_AT_PREP, BASEFORM_POS_SHEL_PREP, BASEFORM_POS_VERB, BASEFORM_POS_PREPOSITION, BASEFORM_POS_ADVERB, BASEFORM_POS_INTERJECTION]
// convert the numbers to the index in the list..
const POS_WITH_GENDER_AND_NUMBER =  [BASEFORM_POS_LIST.index(pos) for pos in POS_WITH_GENDER_AND_NUMBER]
POS_WITH_PERSON = [BASEFORM_POS_LIST.index(pos) for pos in POS_WITH_PERSON]
POS_WITH_STATUS = [BASEFORM_POS_LIST.index(pos) for pos in POS_WITH_STATUS]
POS_WITH_TENSE = [BASEFORM_POS_LIST.index(pos) for pos in POS_WITH_TENSE]
POS_WITH_PREFIX = [BASEFORM_POS_LIST.index(pos) for pos in POS_WITH_PREFIX]
POS_WITH_SUFFIX = [BASEFORM_POS_LIST.index(pos) for pos in POS_WITH_SUFFIX]
*/

const SKIP_MORPHOLOGY_WITH_ONE_OF_THESE = ['BASEFORM_POS_CONTINUE', 'BASEFORM_POS_JUNK', 'BASEFORM_POS_UNKNOWN']

function getIndexOfSwitchedOne(arrayOfObjects, thisObject, twoItems) {
  var toReturn = -1
  arrayOfObjects.forEach((oneObject, i) => {
    if ((_.isEqual(oneObject.list.filter(el => el !== twoItems[0]).sort(),
      thisObject.list.filter(el => el !== twoItems[1]).sort())
      || _.isEqual(oneObject.list.filter(el => el !== twoItems[1]).sort(),
        thisObject.list.filter(el => el !== twoItems[0]).sort()))
      && oneObject.lexeme === thisObject.lexeme
    ) toReturn = i // shouldn't be ABLE to happen more than once
  })
  return toReturn
}

function prettyPrintedMorphArray(morphArray) {
  var morphStringsAndLexemes = [] // abbreviated from here on M.S.A.L.
  const isItJustOne = morphArray.length === 2 && !(Array.isArray(morphArray[0]))
  const realMorphArray = isItJustOne ? [morphArray] : morphArray
  realMorphArray.forEach(morphPair => {
    const thisMsalObj = { list: getAllMorphStrings(morphPair[0]), lexeme: morphPair[1] }
    if (!(thisMsalObj.list.length === 1 && thisMsalObj.list[0] === 'BASEFORM_POS_NONSTANDARD')
      || realMorphArray.length === 1) {
      var twoItems = ['BASEFORM_GENDER_MASCULINE', 'BASEFORM_GENDER_FEMININE']
      var indexOfSwitchedOne = getIndexOfSwitchedOne(morphStringsAndLexemes, thisMsalObj, twoItems)
      if (indexOfSwitchedOne !== -1) {
        morphStringsAndLexemes[indexOfSwitchedOne].list = morphStringsAndLexemes[indexOfSwitchedOne].list.filter(morphString => !(twoItems.includes(morphString)))
      } else {
        twoItems = ['SUFFIX_GENDER_MASCULINE', 'SUFFIX_GENDER_FEMININE']
        indexOfSwitchedOne = getIndexOfSwitchedOne(morphStringsAndLexemes, thisMsalObj, twoItems)
        if (indexOfSwitchedOne !== -1) {
          morphStringsAndLexemes[indexOfSwitchedOne].list = morphStringsAndLexemes[indexOfSwitchedOne].list.filter(morphString => !(twoItems.includes(morphString)))
        } else {
          twoItems = ['BASEFORM_STATUS_ABSOLUTE', 'BASEFORM_STATUS_CONSTRUCT']
          indexOfSwitchedOne = getIndexOfSwitchedOne(morphStringsAndLexemes, thisMsalObj, twoItems)
          if (indexOfSwitchedOne !== -1) {
            morphStringsAndLexemes[indexOfSwitchedOne].list = morphStringsAndLexemes[indexOfSwitchedOne].list.filter(morphString => !(twoItems.includes(morphString)))
          } else {
            const superfluousMorphs = ['BASEFORM_STATUS_ABSOLUTE', 'BASEFORM_PERSON_ANY', 'SUFFIX_PERSON_ANY',
              'BASEFORM_GENDER_MASCULINEFEMININE', 'SUFFIX_GENDER_MASCULINEFEMININE']
            thisMsalObj.list = thisMsalObj.list.filter(morphString => !(superfluousMorphs.includes(morphString)))
            if (thisMsalObj.lexeme.includes('ֽ')) {
              thisMsalObj.lexeme = thisMsalObj.lexeme.replace(/[אהוי]ֽ/g, '')
              if (morphStringsAndLexemes.map(msalObj => msalObj.lexeme === thisMsalObj.lexeme && _.isEqual(msalObj.list.slice().sort(), thisMsalObj.list.slice().sort())).length === 0) morphStringsAndLexemes.push(thisMsalObj)
            } else morphStringsAndLexemes.push(thisMsalObj)
          }
        }
      }
    }
  })

  // console.log(morphStringsAndLexemes)
  return morphStringsAndLexemes.map(msalObj => {
    const morphStringsText = msalObj.list.map(
      function (item) { return morphologyIdDict.hasOwnProperty(item) ? morphologyIdDict[item] : item }
    ).join(', ').replace(/:,/g, ':').replace(/תחילית: בסיס: /, '').replace(/, בסיס:$/, '')
      .replace(/, סיומת:$/, '').replace(/(תחילית: )מיידע(.*סיומת)/, '$1ה\' הזיקה')
    return morphStringsText === 'מקראי' ? morphStringsText
      : morphStringsText.length ? '<b>' + msalObj.lexeme + '</b>, ' + morphStringsText : ''
  })
}

function getAllMorphStrings(fullMorphBMstring) {
  const fullMorphBMtoLong = Long.fromString(fullMorphBMstring)
  var morphStrings = []
  PREFIX_FUNCTION_LIST.forEach((bm, i) => {
    if (fullMorphBMtoLong.and(bm).compare(bm) === 0 && PREFIX_FUNCTION_NUM_TO_STR[i] !== '_UNK_') {
      if (!(morphStrings.length)) morphStrings.push('PREFIX')
      morphStrings.push(PREFIX_FUNCTION_NUM_TO_STR[i])
    }
  })
  if (morphStrings.length) morphStrings.push('BASEFORM')
  var toCompare = fullMorphBMtoLong.and(BASEFORM_POS)
  BASEFORM_POS_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) {
      if (SKIP_MORPHOLOGY_WITH_ONE_OF_THESE.includes(BASEFORM_POS_NUM_TO_STR[i])) return []
      morphStrings.push(BASEFORM_POS_NUM_TO_STR[i])
    }
  })
  toCompare = fullMorphBMtoLong.and(BASEFORM_BINYAN)
  BASEFORM_BINYAN_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) {
      if (morphStrings[morphStrings.length - 1] === 'BASEFORM_POS_VERB') morphStrings.pop()
      morphStrings.push(BASEFORM_BINYAN_NUM_TO_STR[i])
    }
  })
  toCompare = fullMorphBMtoLong.and(BASEFORM_GENDER)
  BASEFORM_GENDER_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) morphStrings.push(BASEFORM_GENDER_NUM_TO_STR[i])
  })
  toCompare = fullMorphBMtoLong.and(BASEFORM_NUMBER)
  BASEFORM_NUMBER_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) morphStrings.push(BASEFORM_NUMBER_NUM_TO_STR[i])
  })
  toCompare = fullMorphBMtoLong.and(BASEFORM_PERSON)
  BASEFORM_PERSON_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) morphStrings.push(BASEFORM_PERSON_NUM_TO_STR[i])
  })
  toCompare = fullMorphBMtoLong.and(BASEFORM_STATUS)
  BASEFORM_STATUS_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) morphStrings.push(BASEFORM_STATUS_NUM_TO_STR[i])
  })
  toCompare = fullMorphBMtoLong.and(BASEFORM_TENSE)
  BASEFORM_TENSE_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) morphStrings.push(BASEFORM_TENSE_NUM_TO_STR[i])
  })
  toCompare = fullMorphBMtoLong.and(SUFFIX_FUNCTION)
  var suffixAlreadyAdded = false
  SUFFIX_FUNCTION_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0 && SUFFIX_FUNCTION_NUM_TO_STR[i] !== '_UNK_') {
      if (!suffixAlreadyAdded) { morphStrings.push('SUFFIX'); suffixAlreadyAdded = true }
      morphStrings.push(SUFFIX_FUNCTION_NUM_TO_STR[i])
    }
  })
  toCompare = fullMorphBMtoLong.and(SUFFIX_GENDER)
  SUFFIX_GENDER_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) {
      if (!suffixAlreadyAdded) { morphStrings.push('SUFFIX'); suffixAlreadyAdded = true } // shouldn't be needed
      morphStrings.push(SUFFIX_GENDER_NUM_TO_STR[i])
    }
  })
  toCompare = fullMorphBMtoLong.and(SUFFIX_NUMBER)
  SUFFIX_NUMBER_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) {
      if (!suffixAlreadyAdded) { morphStrings.push('SUFFIX'); suffixAlreadyAdded = true } // shouldn't be needed
      morphStrings.push(SUFFIX_NUMBER_NUM_TO_STR[i])
    }
  })
  toCompare = fullMorphBMtoLong.and(SUFFIX_PERSON)
  SUFFIX_PERSON_LIST.forEach((bm, i) => {
    if (toCompare.compare(bm) === 0) {
      if (!suffixAlreadyAdded) { morphStrings.push('SUFFIX'); suffixAlreadyAdded = true } // shouldn't be needed
      morphStrings.push(SUFFIX_PERSON_NUM_TO_STR[i])
    }
  })
  if ((fullMorphBMtoLong.and(FULLFORM_ARAMAIC)).compare(FULLFORM_ARAMAIC) === 0) morphStrings.push('ARAMAIC')
  // console.log(morphStrings)
  return morphStrings.filter(ms => ms !== '_UNK_')
}

function genderOfOption(o) {
  var allStrings = []
  o.morphArray.forEach(m => {
    const stringArray = getAllMorphStrings(m[0])
    const person2Components = stringArray.filter(s => s.includes('PERSON_2'))
      .map(s => s.split('_')[0])
    // console.log('person2Components:')
    // console.log(person2Components)
    person2Components.forEach(p2c => {
      allStrings.push(...(stringArray.filter(s => s.split('_')[0] === p2c)))
    })
  })
  // console.log('allStrings:')
  // console.log(allStrings)
  const hasMasculine = allStrings.filter(s => s.includes('MASCULINE')).length
  const hasFeminine = allStrings.filter(s => s.includes('FEMININE')).length
  // console.log('hasMasculine:')
  // console.log(hasMasculine)
  // console.log('hasFeminine:')
  // console.log(hasFeminine)
  return (hasMasculine && !hasFeminine) ? 'M' : ((hasFeminine && !hasMasculine) ? 'F' : '')
}

export {
  prettyPrintedMorphArray, // [for NikudOptionsPane]
  genderOfOption, /* [for the resultsIntegrationMixins method buildExpandedOptions(), which is used
    (indirectly) by NikudEdit, EditNikudPane, and ManualNikudPane] */
  getAllMorphStrings, //for morphology (used in nikudOptionsPaneKeyMap but only in code that's commented out at the time of this writing)
}
